import * as React from 'react'

import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md'
import './styles.scss'

interface Props {
  currentPage: number
  totalPages: number
  onPageChange: (pageSelected: number) => void
}

export const Paginator = ({ currentPage, totalPages, onPageChange }: Props) => {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers = []
    pageNumbers.push(1)

    const viewType = window.innerWidth < 480 ? {max: 2, min: 0} : {max: 4, min: 2}


    if (currentPage > viewType.max) {
      pageNumbers.push('...')
    }

    const startPage = Math.max(currentPage - viewType.min, 2)
    const endPage = currentPage > viewType.max ? Math.min(currentPage + viewType.min, totalPages - 1) : Math.min(currentPage + viewType.max, totalPages - 1) 
    

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i)
    }

    if (currentPage + viewType.max < totalPages) {
      pageNumbers.push('...')
    }

    if (totalPages > 1) {
      pageNumbers.push(totalPages)
    }

    return pageNumbers
  }

  

  return (
    <div className="paginator">
      <button
        disabled={currentPage === 1}
        onClick={handlePreviousPage}
        className="paginator-button"
      >
        <MdArrowBackIos size={12} />
      </button>
      <span className="paginator-info">
        {renderPageNumbers().map((page, index) => (
          <button
            key={index}
            disabled={typeof page !== 'number'}
            onClick={() => typeof page === 'number' && onPageChange(page)}
            className={`paginator-page ${currentPage === page ? 'paginator-page-selected' : ''} ${
              typeof page !== 'number' ? 'paginator-divider' : ''
            }`}
            >
            {page}
          </button>
        ))}
      </span>
      <button
        onClick={handleNextPage}
        className="paginator-button"
        disabled={currentPage === totalPages}
      >
        <MdArrowForwardIos size={12} />
      </button>
    </div>
  )
}
